const hasTagRegex = new RegExp(/<\/?[a-z][a-z0-9]*\b[^>]*>/i);

export default function normalizeAttributeValue(value: string) {
    const isHTML = hasTagRegex.test(value);

    return isHTML ? value : value.replaceAll('\n', '<br />');
}
